import { useSelector } from 'react-redux';
import { getCurrentContractId } from 'reducers/current-contract';

const useCurrentContractId = () => (
  useSelector((state) => getCurrentContractId(state))
);

export default useCurrentContractId;
